/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import {is_breakpoint_up, translation, scroll_to, is_visible_in_view, config} from '../helpers/functions';
import Swiper from './../libs/swiper';
import App from './../helpers/app';

$(function(){
    function initGallery(){
        let $section = $('.section-offer-used-hero');
        if(!$section.length){
            return;
        }

        let swiperNavigation = new Swiper("#swiperNavigation", {
            spaceBetween: 25,
            slidesPerView: 7,
            freeMode: true,
            watchSlidesProgress: true,
            preloadImages: false,
            lazy: {
                preloaderClass: 'swiper-preloader',
                loadPrevNext: true,
                loadPrevNextAmount: 2
            },
        });

        let swiperGallery = new Swiper("#swiperGallery", {
            spaceBetween: 0,
            navigation: {
                nextEl: '.gallery-nav .next',
                prevEl: '.gallery-nav .prev',
            },
            pagination: {
                el: ".gallery-pagination",
                type: "fraction",
            },
            thumbs: {
                swiper: swiperNavigation,
            },
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 2
            },
        });
    }

    initGallery();
});
